/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {forwardRef, useEffect, useState} from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_helpers";
import {Link, useLocation} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HasReadAccess, IsPortalUser} from "../../../../_helpers/AccessControlHelpers";
import OrderWarning from "../../modal/OrderWarningModal";
import { deleteOrder } from "../../../../../app/modules/Sale/_redux/orders/ordersActions";
import {ORDER_MODEL} from "../../../../_helpers/AppModels";

const QuickActionsDropdownToggle = forwardRef((props, ref) => {
  return (
    <a
      ref={ref}
      href="#"
      onClick={(e) => {
        e.preventDefault();
        props.onClick(e);
      }}
      id="kt_subheader_quick_actions"
      className="btn btn-sm btn-clean btn-icon"
    >
      {" "}
      <span className="svg-icon svg-icon-success svg-icon-lg">
        <span className="svg-icon-success svg-icon-2x">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")} />
        </span>
      </span>
    </a>
  );
});

export function QuickActions() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [triggerModal, setTriggerModal] = useState(false);
  const location = useLocation();

  const handleQuit = () => {
    console.log("quit now");
    dispatch(deleteOrder());
    onHide();
  };

  const onHide = () => {
    setTriggerModal(false);
  };

  if (location.pathname !== "/sales/orders/new") {
    return null;
  }

  return (
    <>
      {triggerModal && (
        <OrderWarning
          onHide={onHide}
          show={triggerModal}
          handleQuit={handleQuit}
        />
      )}

      <OverlayTrigger
        placement="right"
        overlay={<Tooltip id="quick-actions-tooltip">مشاهده سبد خرید</Tooltip>}
      >
        <>
          {(IsPortalUser(user) && HasReadAccess(user, ORDER_MODEL) ) &&  location.pathname === '/sales/orders/new' && (
            <>
              <Link
                to={"/sales/orders/cart"}
                className={"btn btn-primary mr-2"}
              >
                مشاهده کامل سفارش
                <span className="svg-icon svg-icon-white svg-icon-2x">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")}
                  />
                </span>
              </Link>

              <button
                className={"btn btn-light-primary p-4"}
                onClick={() => setTriggerModal(true)}
              >
                ابطال سفارش
                <span className="svg-icon svg-icon-white svg-icon-2x ml-2">
                  <i className={"fa fa-arrow-left"} />
                </span>
              </button>
            </>
          )}
        </>
      </OverlayTrigger>
    </>
  );
}
